module.exports = __webpack_public_path__ + "assets/img/projects_item7.c8c34a19.png";